import { defineChart } from '..'
import { registerMap } from 'echarts'
import { tooltip } from '@/composables/useChart/theme'
import geoJSON from '@/assets/world.geo.json'
import type { Piece } from './bubble'
import type { Values } from '@/composables/useValues'

// @ts-expect-error wrong geo types
registerMap('world', { geoJSON })

type Params = [Values, Piece[]]

/**
 * Create the world map chart options.
 */
export default defineChart<Params>(({ sorted, dimension }, pieces) => {
    if (!dimension || !sorted) return

    return {
        tooltip: {
            formatter(params) {
                if (Array.isArray(params)) return ''

                const value = pieces.find(
                    ({ value }) => value === params.value
                )?.label

                const country = params.name

                return tooltip(dimension?.name ?? '', country, value ?? '')
            }
        },
        grid: {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            containLabel: false
        },
        visualMap: {
            type: 'piecewise',
            pieces,
            show: false,
            bottom: '5%'
        },
        series: [
            {
                type: 'map',
                map: 'world',
                height: '100%',
                nameProperty: 'iso',
                showLegendSymbol: false,
                universalTransition: true,
                data: sorted.map(item => ({
                    name: item.iso,
                    value: item.score
                }))
            }
        ],
        export: {
            visualMap: {
                show: true
            },
            series: {
                top: '10%',
                height: '75%'
            }
        }
    }
})
